import { detectPlatform } from "./platform.js";

/** Register the app-shell service worker — web origin only.
 *
 * Skipped in dev (would fight Vite HMR) and in the Capacitor/Tauri shells
 * (they load bundled assets directly; an SW caching layer there only risks
 * serving stale assets after an app update). See public/sw.js for the strategy.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (detectPlatform() !== "browser") return;
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((e: unknown) => {
      console.warn("service worker registration failed", e);
    });
  });
}
